import ChatPage from "@/pages/chat/chat-page";
import { RouteConfig } from "../types";

export const chatRoutes: RouteConfig[] = [
  //{ path: "/", component: ChatPage },
  { path: "/chat", component: ChatPage },
];
